import log from 'salvo-lite/log'

class FaqSection {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const faqs = this._elem.querySelectorAll('.faq-section__faq')
        if (faqs.length > 0) {
            for (const faq of faqs) {
                faq.addEventListener('click', e => {
                    const section = e.target.parentElement
                    const isOpen = section.classList.contains('accordion--open')

                    for (const faq2 of faqs) {
                        faq2.classList.remove('accordion--open')
                    }

                    if (!isOpen) {
                        section.classList.add('accordion--open')
                        const wrapepr = document.querySelector('.faq-section__faqs-wrapper')
                        wrapepr.classList.remove('accordion--open')

                        const accordionTop = section.getBoundingClientRect().top
                        const documentTop = document.body.getBoundingClientRect().top
                        setTimeout(() => {
                            window.scrollTo({
                                behavior: 'smooth',
                                top: accordionTop - documentTop - 200
                            })
                        }, 25)
                    }
                })
            }
        }
    }
}

export default FaqSection



// WEBPACK FOOTER //
// ./src/resources/scripts/components/faqSection.js